exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-light-yellow{background-color:#ffffe0}.bg-light-grey{background-color:#d3d3d3}.bg-light-red{background-color:#f8d7da}", ""]);

// exports
